import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setRedirectPath } from "../../modules/actions/authActions";
import { getCart } from "../../modules/actions/cartActions";
import { addToCart } from "../../modules/actions/cartActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import getHistoryState from "history/createBrowserHistory";
import "react-datepicker/dist/react-datepicker.css";
import { Link, withRouter } from "react-router-dom";
import qs from "qs";
import { format } from "../../modules/utils"
import scrollToElement from "scroll-to-element";

class SimCartController extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            startDate: moment().add(7,'days'),
            useType: "GLOBAL",
            receiveType: "DELIVERY",
            returnType: "Mail",
            shippingFee: 0,
            quantity: 1,
            product : {}
        };
    }

    onStartDateChange = date => {
        this.setState({
            startDate : date
        });
    };

    getSubscriptionEndDate(date, period, unit = 'days'){
        return moment(date).add(period - 1 ,unit);
    }

    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };

    addToCart = () => {
        const { product, useType, receiveType, returnType, shippingFee, quantity } = this.state;
        const sessionId = localStorage.getItem("sessionId");
        const productId = product._id;
        const subtotal = product.globalPrice;
        const total = product.globalPrice;
        const startDate = format(this.state.startDate);
        const endDate = format(this.getSubscriptionEndDate(startDate,product.recurringPeriod));

        let payload = {
            startDate,
            endDate,
            useType,
            receiveType,
            returnType,
            quantity,
            sessionId,
            total,
            subtotal,
            shippingFee,
            productId,
            product,
            cartType: "sim"
        };

        this.performCartAction(payload);
    };

    performCartAction(payload){
        const { auth } = this.props;
        if (auth.isAuthenticated) {
            this.props
                .addToCart(payload)
                .then(data => {
                    console.log(data);
                    if (data.status) {
                        this.context.router.history.push({
                            pathname: "/checkout",
                            params : {
                                product: this.state.product
                            }
                        });
                    } else {
                        this.showMessage(data.message);
                    }
                })
                .catch(error => {
                    this.showMessage(error.response.data.message);
                });
        } else {
            this.props.setRedirectPath("/checkout", payload);
            this.context.router.history.push({
                pathname : "/login",
                params : {
                        product : payload.product,
                        cart : payload
                }
            });
        }
    }


    componentDidMount() {
        console.log(this.props);
        if (typeof this.props.location.state !== 'undefined' && typeof this.props.location.state.product !== 'undefined'){
            this.setProduct(this.props.location.state.product);
        }
        else if(this.getQueryParams() && typeof this.props.auth.redirectPayload.product !== 'undefined'){
            const payload = this.props.auth.redirectPayload;
            console.log("redirectPayload=", payload);
            this.setProduct(payload.product);
            this.performCartAction(payload)
        }
        else{
            this.props.history.push("/get-sim");
        }

        if (typeof this.props.location.state !== 'undefined' && typeof this.props.location.state.anchor !== 'undefined') {
            scrollToElement("#" + this.props.location.state.anchor, { offset: 0 });
        }
    }

    setProduct(payload){
        this.setState({
            product :  {...payload}
        });
    }

    getQueryParams(){
        const qsParsed = qs.parse(
            this.context.router.history.location.search.slice(1)
        );
        return !!qsParsed.login;
    }

    render() {
        const { product } = this.state;
        return(
                    <section className="BodyContainer">
                        <div className="container">
                            <div className="row position-relative">


                                <div className="col-lg-4 services_img_bg">
                                    <img src={product.image}/>
                                </div>



                                <div className="col-lg-8 sim_services_clip">
                                    <div className="services_bg_pad">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="services_boxes mt-3 rounded p-4">

                                                    <div className="services_content mt-3">

                                                        <h5 className="SansSerif">{product.shortDescription}</h5>
                                                        <h3 className="m-Title SansSerif bold700 product-btn">{product.name} ${product.globalPrice}</h3>

                                                        <div style={{ clear: "both", height: "20px" }} />

                                                        <h5 className="mb-0">Select the date you wish to have the SIM card activated</h5>
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <div className="form-group mt-3">
                                                                    <DatePicker
                                                                        className="form-control data-field half-input line-input"
                                                                        selected={this.state.startDate}
                                                                        minDate={moment().add(7,'days')}
                                                                        onChange={this.onStartDateChange}
                                                                        id="startDate"
                                                                        placeholderText="Start Date"
                                                                        onChangeRaw={event => {
                                                                            event.preventDefault();
                                                                        }}
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>*Please allow 7 days for processing and transit times</div>

                                                        <div className="bold-box">
                                                          <h5 style={{ margin: "0px"}}>
                                                          Selected Date : <span className="m-break">{this.state.startDate.format('MM/DD/YYYY')} ~ {this.getSubscriptionEndDate(this.state.startDate,product.recurringPeriod).format('MM/DD/YYYY')}</span>
                                                          </h5>
                                                        </div>

                                                        <div style={{clear: 'both', height: '20px'}}></div>

                                                        <a href="javascript:void(0)" className="btn btn-white" onClick={this.addToCart}>Continue</a>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
        );
    }
}


SimCartController.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart
    };
}

export default withRouter(connect(
    mapStateToProps,
    { addToCart, addFlashMessage, setRedirectPath, getCart }
)(SimCartController));



// WEBPACK FOOTER //
// ./src/pages/simCart/SimCart.js